<template>
  <div class="search_container searchArea">
    
    <el-col :gutter="10">
      <el-row>
        <div class="grid-content bg-purple"></div>
      </el-row>
      <el-row>
        <div class="grid-content bg-purple"></div>
      </el-row>
      <el-row>
        <div class="grid-content bg-purple"></div>
      </el-row>
      <el-row>
        <div class="grid-content bg-purple"></div>
      </el-row>
      <el-row>
        <div class="grid-content bg-purple"></div>
      </el-row>
    </el-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "searchItem",
  data() {
    return {
      search_data: {},
      rules: {
        name: [{ required: true, message: "请输入手机号", trigger: "blur" }]
      }
    };
  },
  computed: {
    // ...mapGetters(["courseSearchBtnDisabled"])
  },
  created() {},
  methods: {
    onScreeoutMoney(searchForm) {
      this.$refs[searchForm].validate(valid => {
        if (valid) {
          // console.log("emit search")
          this.$store.commit("SET_MEMBER_SEARCH", this.search_data);
          this.$emit("searchList");
        }
      });
    },
    onAddMember() {
      this.$emit("showDialog", "add");
    },
    onBatchDelMember() {
      //   console.log("batchdelmember");
      this.$emit("batchDelMember");
    }
  }
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
